import { FC, useContext, useState } from 'react';
import { Box, Collapse, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BasicExpand from '../common/BasicExpand';
import { CampaignContext } from '../../contexts/CampaignContext';

type IFinishedCampaignExpand = {};

const FinishedCampaignExpand: FC<IFinishedCampaignExpand> = () => {
	const [expanded, setExpanded] = useState(false);

	const { fetchedCampaign } = useContext(CampaignContext);

	const { screenshot } = fetchedCampaign!;

	const { t } = useTranslation();

	const handleExpand = () => {
		setExpanded(prev => !prev);
	};

	// const [copied, setCopied] = useState<{ type: 'title' | 'handle' | null; index: number | null }>({ type: null, index: null });

	// const copyToClipboard = async (text: string | undefined, type: 'title' | 'handle', index: number) => {
	// 	if (!text) return;
	// 	try {
	// 		await navigator.clipboard.writeText(text);
	// 		setCopied({ type, index });
	// 		setTimeout(() => setCopied({ type: null, index: null }), 1500);
	// 	} catch (e) {
	// 		// fallback: try execCommand if needed
	// 		const textarea = document.createElement('textarea');
	// 		textarea.value = text;
	// 		document.body.appendChild(textarea);
	// 		textarea.select();
	// 		try {
	// 			document.execCommand('copy');
	// 			setCopied({ type, index });
	// 			setTimeout(() => setCopied({ type: null, index: null }), 1500);
	// 		} finally {
	// 			document.body.removeChild(textarea);
	// 		}
	// 	}
	// };

	return (
		<Box className={`${expanded && 'mb-0 pb-8'}`}>
			<BasicExpand title={t('screenshot-for-finished-campaign')} expanded={expanded} onExpand={handleExpand} />
			<Collapse in={expanded} className={`rounded-b-lg bg-background-paper px-6 pb-0 pt-6 ${expanded && 'pb-6'}`}>
				{screenshot?.map((shot, i) => (
					<Box key={i}>
						<Box className="flex w-full justify-between gap-x-4">
							<TextField disabled className="w-3/5" variant="filled" label={t('title')} defaultValue={shot?.screenshot_title} />
							<TextField disabled className="w-2/5" variant="filled" label={t('id-of-advertised-page')} defaultValue={shot?.screenshot_handle_name} />
						</Box>
						<TextField disabled className="my-6" fullWidth variant="filled" id="filled-multiline-static" label={t('description')} multiline rows={4} value={shot?.screenshot_description} />
						<img src={shot?.screenshot_image} alt="screen shot" className="h-[266px] w-80 rounded-2xl" />
					</Box>
				))}
			</Collapse>
		</Box>
	);
};

export default FinishedCampaignExpand;
